import { bootstrapWidget } from "../../common";
import BookingWidget from "./widget";

bootstrapWidget({ widget: BookingWidget, widgetType: "booking" });
